<script lang="ts">
  import {t} from '../i18n'
  import {modal} from '../stores/modal'
  import LoginSocial from './LoginSocial.svelte'
  import api from '../api/api'
  import {navigate} from 'svelte5-router'
  import {user} from '../stores/user'
  import type {User} from '../types'
  import {flash} from '../stores/flash'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import ValidationMessage from '../shared/ValidationMessage.svelte'

  let registration = {email: '', password: '', password_confirmation: '', first_name: '', last_name: ''}
  let errors: string[] | null = null
  let passwordConfirmationInput: HTMLInputElement

  function validate() {
    if (registration.password === registration.password_confirmation) {
      passwordConfirmationInput.setCustomValidity('')
      return true
    } else {
      passwordConfirmationInput.setCustomValidity(t.errors.validation.password_matches)
      return false
    }
  }

  async function submit(e: Event) {
    e.preventDefault()
    if (!validate()) return

    const newUser = await api.post<User>('/register', {user: registration}).catch(response => errors = response.errors)
    modal.close()
    $user = newUser
    navigate('/')
    flash.show(t.flash.register.success)
  }

  function openLoginSocial(e: Event) {
    e.preventDefault()
    modal.show(LoginSocial)
  }
</script>

<ModalTemplate size="tiny">
  <span class="close icon-p-close" onclick={() => modal.close()}></span>

  <div class="modal-content">
    <form onsubmit={submit}>
      <h2 class="reg-log-title">
        <a class="login-btn" onclick={openLoginSocial}>
          {t.authorization.login.title}
        </a>

        <span>{t.authorization.registration.title}</span>
      </h2>

      <div class="line">
        <input required placeholder={t.authorization.login.first_name}
               bind:value={registration.first_name}/>
      </div>

      <div class="line">
        <input required placeholder={t.authorization.login.last_name} bind:value={registration.last_name}/>
      </div>

      <div class="line">
        <input type="email" required placeholder={t.authorization.login.email} bind:value={registration.email}/>
      </div>

      <div class="line">
        <input type="password" required placeholder={t.authorization.login.password}
               minlength={6} maxlength={255}
               bind:value={registration.password}/>
      </div>

      <div class="line">
        <input type="password" required
               placeholder={t.authorization.login.password_confirmation}
               bind:value={registration.password_confirmation}
               bind:this={passwordConfirmationInput}
               oninput={() => passwordConfirmationInput.setCustomValidity('')}/>
        <ValidationMessage {errors}/>
      </div>

      <button type="submit" class="ui button black">{t.authorization.registration.register}</button>
    </form>
  </div>
</ModalTemplate>
